import React from "react";
import HeaderOriginal from "../components/HeaderOriginal/HeaderOriginal";
import StickyNavBar from "../components/Navigation/StickyNavBar";
import Fancybox from "../components/FancyBox";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
const TransparencyBoardCandidates = () => {
  React.useEffect(() => {
    Fancybox.bind("[data-fancybox='images']");
  }, []);
  return (
    <>
      <HeaderOriginal></HeaderOriginal>
      <StickyNavBar></StickyNavBar>
      <div className="max-w-screen-xl mx-auto px-3">
        <div className="text-center mt-8">
          <h2 className="text-primary">الأخبار و التقارير الإعلامية</h2>
          <h1 className="mt-4 text-primary font-bold">
            «سعادة» تعقد لقاء تعريفي لمرشحي الانتخابات القادمة
          </h1>
        </div>

        <div className="mt-10">
          <ul className="text-base">
            <li className="inline-block">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="size-4 inline-block text-green-600 ml-2"
              >
                <path
                  fillRule="evenodd"
                  d="M6.32 2.577a49.255 49.255 0 0 1 11.36 0c1.497.174 2.57 1.46 2.57 2.93V21a.75.75 0 0 1-1.085.67L12 18.089l-7.165 3.583A.75.75 0 0 1 3.75 21V5.507c0-1.47 1.073-2.756 2.57-2.93Z"
                  clipRule="evenodd"
                />
              </svg>

              <NavLink to="/" className="text-primary font-bold">الرئيسية</NavLink>
            </li>
            <li className="inline-block">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="size-4 inline-block text-green-600"
              >
                <path
                  fillRule="evenodd"
                  d="M10.72 11.47a.75.75 0 0 0 0 1.06l7.5 7.5a.75.75 0 1 0 1.06-1.06L12.31 12l6.97-6.97a.75.75 0 0 0-1.06-1.06l-7.5 7.5Z"
                  clipRule="evenodd"
                />
                <path
                  fillRule="evenodd"
                  d="M4.72 11.47a.75.75 0 0 0 0 1.06l7.5 7.5a.75.75 0 1 0 1.06-1.06L6.31 12l6.97-6.97a.75.75 0 0 0-1.06-1.06l-7.5 7.5Z"
                  clipRule="evenodd"
                />
              </svg>

              <NavLink to='/' className="text-primary font-bold">الأخبار و التقارير الإعلامية</NavLink>
            </li>
            <li className="inline-block">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="size-4 inline-block text-green-600"
              >
                <path
                  fillRule="evenodd"
                  d="M10.72 11.47a.75.75 0 0 0 0 1.06l7.5 7.5a.75.75 0 1 0 1.06-1.06L12.31 12l6.97-6.97a.75.75 0 0 0-1.06-1.06l-7.5 7.5Z"
                  clipRule="evenodd"
                />
                <path
                  fillRule="evenodd"
                  d="M4.72 11.47a.75.75 0 0 0 0 1.06l7.5 7.5a.75.75 0 1 0 1.06-1.06L6.31 12l6.97-6.97a.75.75 0 0 0-1.06-1.06l-7.5 7.5Z"
                  clipRule="evenodd"
                />
              </svg>
              <NavLink to="/">«سعادة» تعقد لقاء تعريفي لمرشحي الانتخابات القادمة</NavLink>
            </li>
          </ul>
        </div>
        <div className="md:flex md:gap-4">
          {/* first */}
          <div>
            <div className="mt-10 text-sm">
              <div className="p-4 rounded-sm shadow-lg">
                عقد مجلس إدارة جمعية سيهات للخدمات الاجتماعية برئاسة الأستاذ
                شوقي المطرود والمدير التنفيذي عبدالواحد آل يوسف اجتماعًا بحضور
                ١٤ مُرشّح مساء يوم الاثنين بمقر الجمعية .<br />
                <br />
                وتم في اللقاء الذي عُقد لتعريف أعضاء المجلس الجدد بعمل الجمعية
                وخاصة الجوانب القانونية و توفير المعلومات الوافية عن شؤون
                الجمعية و توجيه المرشحين للإطلاع على السياسات و البيانات
                المنشورة على الموقع الرسمي للجمعية إلى جانب الإجابة على أسئلة و
                استفسارات الحضور.&nbsp;
                <br />
                <br />و استعرض المدير التنفيذي آل يوسف المهام والمسؤوليات
                المتوقعة من عضو مجلس الادارة بحسب اللائحة التنفيذية للجمعيات
                الأهلية، كما تم تناول توجه الجمعية فيما يتعلق بالاستدامة المالية
                و معايير الحوكمة الثلاثة إلى جانب الجهود التي بذلها مجلس الادارة
                الحالي و أهمية استمرار هذه الجهود ممن سيصلون الى مجلس الادارة في
                الدورة القادمة.
                <br />
                <br />
                من جهة أخرى تم استعراض آخر التحديثات ومتطلبات المركز الوطني
                لتنمية القطاع غير الربحي ومناقشة العديد من المواضيع والتي من
                ضمنها اللائحة الأساسية والاسترشادية بالإضافة إلى الحوكمة .<br />
                <br />
                ونوقش في الاجتماع المُدد الزمنية لاستكمال الإجراءات المطلوبة من
                قبل المركز الوطني لتنمية القطاع غير الربحي لتحديد موعد انعقاد
                اجتماع الجمعية العمومية القادم ومنها تحديث بيانات &nbsp; أعضاء
                الجمعية العمومية.
                <br />
                <br />
                وفي كلمة ختامية، وجه المطرود تمنياته للمرشحين بالتوفيق والسداد،
                متمنياً أن يكون المجلس القادم أكثر حرصاً على مسيرة الجمعية، وعلى
                تنمية انجازاتها، والعمل على تحقيق نتائج مثمرة، ومجدية، بطرق
                مبتكرة وجريئة والأهم بتفكير سليم وخطوات مدروسة.
              </div>
            </div>
            <div>
              <h3 className="mt-4 text-primary font-bold">البوم الصور</h3>
              {/* <div className="grid grid-cols-4 gap-4">
            <div className="image_block1">
              <a data-fancybox="images" href="images/first_box.jpg">
                <div
                  preload="true"
                  className="w-16 bg-cover  bg-center"
                  style={{
                    backgroundImage: 'url("images/first_box.jpg")',
                  }}
                />
                <div className="overlay">
                  <i className="fal fa-search-plus" />
                </div>
              </a>
            </div>

            <div>
              <img src="images/Governance/first_box.jpg" alt="" />
            </div>
            <div>
              <img src="images/Governance/first_box.jpg" alt="" />
            </div>
            <div>
              <img src="images/Governance/first_box.jpg" alt="" />
            </div>
            <div>
              <img src="images/Governance/first_box.jpg" alt="" />
            </div>
            <div>
              <img src="images/Governance/first_box.jpg" alt="" />
            </div>
            <div>
              <img src="images/Governance/first_box.jpg" alt="" />
            </div>
          </div> */}

              <Fancybox
                options={{
                  Carousel: {
                    infinite: false,
                  },
                }}
              >
                <div className="grid grid-cols-4 gap-1 mt-4 mb-4">
                  <a
                    data-fancybox="gallery"
                    href="images/Governance/first_box.jpg"
                  >
                    <img
                      alt=""
                      src="images/Governance/first_box.jpg"
                      width="200"
                      height="150"
                    />
                  </a>
                  <a
                    data-fancybox="gallery"
                    href="images/Governance/second_box.jpg"
                  >
                    <img
                      alt=""
                      src="images/Governance/second_box.jpg"
                      width="200"
                      height="150"
                    />
                  </a>
                  <a
                    data-fancybox="gallery"
                    href="images/Governance/third_box.jpg"
                  >
                    <img
                      alt=""
                      src="images/Governance/third_box.jpg"
                      width="200"
                      height="150"
                    />
                  </a>
                  <a
                    data-fancybox="gallery"
                    href="images/Governance/fourth_box.jpg"
                  >
                    <img
                      alt=""
                      src="images/Governance/fourth_box.jpg"
                      width="200"
                      height="150"
                    />
                  </a>
                  <a
                    data-fancybox="gallery"
                    href="images/Governance/fifth_box.jpg"
                  >
                    <img
                      alt=""
                      src="images/Governance/fifth_box.jpg"
                      width="200"
                      height="150"
                    />
                  </a>
                  <a
                    data-fancybox="gallery"
                    href="images/Governance/sixth_box.jpg"
                  >
                    <img
                      alt=""
                      src="images/Governance/sixth_box.jpg"
                      width="200"
                      height="150"
                    />
                  </a>
                </div>
              </Fancybox>
            </div>
          </div>

          {/* second */}
          <div>
            <div className="mt-4">
              <a data-fancybox="gallery" href="images/Governance/big_box.jpg">
                <img
                  alt=""
                  src="images/Governance/big_box.jpg"
                  className="w-full"
                />
              </a>
              <div className="mt-4">
                <h3 className="text-primary">إقرأ أيضا</h3>
                <ul className="text-base shadow-lg rounded-md text-slate-500 mt-4 py-4 px-2">
                  <li className="mt-2">
                    <a href="news/في-اجتماعه-لتقييم-نتائج-الربع-الثالث:-مجلس-إدارة-سعادة-يبارك-جهود-الجميع-ويبحث-تذليل-العقبات/">
                      في اجتماعه لتقييم نتائج الربع الثالث: مجلس إدارة « سعادة »
                      يبارك جهود الجميع ويبحث تذليل العقبات
                    </a>
                  </li>
                  <li className="mt-2">
                    <a href="news/البنك-الأهلي-السعودي-يدعم-برامج-مسني-سعادة/">
                      البنك الأهلي السعودي يدعم برامج مسني "سعادة"
                    </a>
                  </li>
                  <li className="mt-2">
                    <a href="news/نزلاء-مركز-سعادة-في-استضافة-نادي-الصفا/">
                      نزلاء «مركز سعادة» في استضافة نادي الصفا
                    </a>
                  </li>
                  <li className="mt-2">
                    <a href="news/سعادة-تلتقي-جمعيات-المحافظة-لبحث-المشاركة-المجتمعية-في-يوم-التطوع-السعودي-والعالمي/">
                      "سعادة" تلتقي جمعيات المحافظة لبحث المشاركة المجتمعية في
                      يوم التطوع السعودي والعالمي
                    </a>
                  </li>
                  <li className="mt-2">
                    <a href="news/سعادة-وجمعية-أسر-التوحد-تبحثان-سبل-التعاون-المشتركة/">
                      «سعادة» وجمعية «أسر التوحد» تبحثان سبل التعاون المشتركة
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <h3 className="mt-4 text-primary">مشاركة</h3>
            <ul className="flex gap-2 my-4">
              <li>
                <NavLink to="/">
                  <img src="images/facebook.png" className="size-8" alt="" />
                </NavLink>
              </li>
              <li>
                <NavLink to="/">
                  <img src="images/twitter.png" className="size-8" alt="" />
                </NavLink>
              </li>
              <li>
                <NavLink to="/">
                  <img src="images/youtube.png" className="size-8" alt="" />
                </NavLink>
              </li>
              <li>
                <NavLink to="/">
                  <img src="images/instagram.png" className="size-8" alt="" />
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
};

export default TransparencyBoardCandidates;
